import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { resetQueries } from '@/utils/api'

import { GET_VENDORS_BASE_QUERY_KEY } from './get-vendors'

type AddVisitorVendorRequest = {
  formData: FormData
}

const addVisitorVendor = async ({ formData }: AddVisitorVendorRequest): Promise<void> => {
  await authAPI.post('/vendor/create-by-employee', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export const useAddVisitorVendor = () => {
  return useMutation({
    mutationFn: addVisitorVendor,
    onSuccess: async () => {
      await resetQueries([GET_VENDORS_BASE_QUERY_KEY])
    },
  })
}
